module.exports = __webpack_public_path__ + "img/62.f4bbbbc4.jpg";